import { apiConfig } from "@shared/integrations/APIIntegration";
import { Logger } from "@shared/utils/Logger";

let env = process.env.REACT_APP_FRONT_ENV || 'PROD';
let analyticsEnv = process.env.REACT_APP_ANALYTICS_ENV ?? env
Logger.log("analytics env", analyticsEnv)

class URLs {
    static qa = "https://qa-analytics.qeeptouch.com" 
    static prod = "https://analytics.qeeptouch.com"
    static local = "http://localhost:8081"
}

let analyticsBaseURL
switch (analyticsEnv) {
    case "PROD":
        analyticsBaseURL = URLs.prod
        break
    case "LOCAL":
        Logger.log("analytics", "local url for analytics")
        analyticsBaseURL = URLs.local
        break
    default:
        Logger.log("analytics", "default url for analytics")
        analyticsBaseURL = URLs.qa
}

Logger.log("analytics url", analyticsBaseURL)

export namespace SystemURL {
    export enum Demo {
        postCreateOrUpdateUser = '/api/demo-web/user',
        postValidateCode = '/api/demo-web/user/validate-code',
        postCreateQP = '/api/demo-web/qontact-point',
        getPresenteeismTable = '/api/demo-web/presenteeism-table',
        postRefreshToken = '/api/demo-web/user/refresh-token',
    }

    export enum Analytics {
        postEvent = "/api/analytics/event"
    }
}

function getBaseURL(template: string): string {
    switch (template) {
        case SystemURL.Analytics.postEvent:
            return analyticsBaseURL
        default:
            return apiConfig.baseURL
    }
}

export const buildURL = (urlTemplate: string, variables: Record<string, string> = {}): string => {
    const url = urlTemplate.replace(/:([A-Za-z0-9_]+)/g, (_, key: string) => {
        if (!(key in variables)) {
            throw new Error(`buildURL: missing value for ":${key}"`);
        }
        return encodeURIComponent(variables[key]);
    });

    return `${getBaseURL(urlTemplate)}${url}`;
};